<template>
  <sui-page>
    <sui-page-header :title="$t('MSG_TIT_APP_MGT')" :pageId="this.$options.name"> </sui-page-header>
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row" >
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_STD_TYP')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-code-select ref="standardTypeOptions"
              :selected="selectData.COD_DATA_STD_DIV"
              :pageId="this.$options.name"
              codeId="COD_DATA_STD_DIV"
              :disabled="false"
              :defaultOption="'all'"
              />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_APPL_TYP')" :vertical="false" />
          </div>
          <div class="col-xs-5">
           <sui-code-select ref="appTypeOptions"
              :selected="selectData.COD_DATA_STD_APPL_DIV "
              :pageId="this.$options.name"
              codeId="COD_DATA_STD_APPL_DIV"
              :disabled="false"
              :defaultOption="'all'"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_STD_LGC_NM')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field maxlength="100" placeholder="" default value :disabled="false" @keyup="onKeyUpInput($event,'logicName',standardLogicNameField)" :clearable="true" :readonly="false" v-model="standardLogicNameField" @keyup.enter="searchApplications"></sui-text-field>
          </div>        
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PRCS_STT')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-code-select ref="processingStateOptions"
              :selected="selectData.COD_DATA_STD_APRV_PRGS_STT "
              :pageId="this.$options.name"
              codeId="COD_DATA_STD_APRV_PRGS_STT"
              :disabled="false"
              :defaultOption="'all'"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_APPL_NM')" :vertical="false" />
          </div>
          <div class="col-xs-5">
           <sui-text-field placeholder="" maxlength="100" default value :disabled="false" @keyup="onKeyUpInput($event,'applicantName',applicantNameField)" :clearable="true" :readonly="false" v-model="applicantNameField" @keyup.enter="searchApplications"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_APPL_DT')" :required="true" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="dp"
              v-model="selectedRangeDate"
              @confirm="onConfirm"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_MDLE')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select ref="moduleOptions"
              :page-id="this.$options.name"
              :selected-md="selectData.moduleCode"
              :selected-smd="selectData.subModuleCode"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PENDING')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-code-select ref="pendencyOptions"
              :selected="selectData.COD_APRV_PDNG_DIV"
              :pageId="this.$options.name"
              codeId="COD_APRV_PDNG_DIV"
              :disabled="false"
              :defaultOption="'all'"
              />
          </div>       
        </div>
        <div class="btn_wrap">
          <sui-button type="button" class="comm_btn_Reset " @click="reset()">{{$t('MSG_BTN_RESET')}}</sui-button>
          <sui-button type="button" class="comm_btn_Scr" @click="searchApplications()" v-permission:read="this.$options.name" >{{$t('MSG_BTN_SEARCH')}}</sui-button>
        </div>
      </div>
      <div class="mrB30"></div>
      <div id="tableDisplay" v-if="showMetauserBtn">
              <sui-grid ref="grdList"
                  :dataset="'dsData'"
                  :columns="gridColumns1"
                  :enabletooltips="true"
                  :initialPagesize="5"
                  :showDisplayCountControl="false"
                  :multiselect="true"
                  @rowselect="onSelectRow"
                  @rowunselect="onUnselectRow">
                  <div class="btn_wrapR">
                    <sui-button type="button" class="comm_btn_gridTop comm_ico_excel" @click="excelDownload" v-permission:download="this.$options.name" >{{$t('MSG_BTN_EXCEL_DOWN')}}</sui-button>
                  </div>

                </sui-grid>
      </div>
      <div id="tableDisplay" v-if="!showMetauserBtn">
              <sui-grid ref="grdList"
                  :dataset="'dsData'"
                  :columns="gridColumns1"
                  :enabletooltips="true"
                  :showDisplayCountControl="false"
                  @rowselect="onSelectRow">
                  <div class="btn_wrapR">
                    <sui-button type="button" class="comm_btn_gridTop comm_ico_excel" @click="excelDownload" v-permission:download="this.$options.name" >{{$t('MSG_BTN_EXCEL_DOWN')}}</sui-button>
                  </div>
              </sui-grid>
      </div>
      <div class="comm_btn_wrap" v-if="showIfKnoxAprvN" >
       <sui-button type="button" class="comm_btn_border_Prime" v-if="!showMetauserBtn" :disabled="revokeStatus" @click="cancelApplication()">{{$t('MSG_BTN_CANCEL')}}</sui-button>
       <sui-button type="button" class="comm_btn_border" v-if="showMetauserBtn" :disabled="approveStatus" @click="individualApprove()">{{$t('MSG_BTN_INDV_APRV')}}</sui-button>
       <sui-button type="button" class="comm_btn_border" v-if="showMetauserBtn" :disabled="batchApproveStatus" @click="batchApprove()">{{$t('MSG_BTN_BLK_APRV')}}</sui-button>
       <sui-button type="button" class="comm_btn_border_Prime" v-if="showMetauserBtn" :disabled="batchRejectStatus" @click="batchReturn()">{{$t('MSG_BTN_BLK_RJT')}}</sui-button>
      </div>
      <div class="mrB30"></div>
      <div class="comm_title_wrap">
        <h4>{{$t('MSG_TXT_REQ_HIST')}}</h4>
      </div>
      <div class="mrT10"></div>
      <sui-grid ref="historyGrid"
          :dataset="'datasetInfo'"
          :columns="defaultGridData1.columns"
          :enabletooltips="true"
          :showDisplayCountControl="false"
          />
      <sui-popup v-model="showWordPopup" :title="$t('MSG_TIT_RTV_STD_REQ')">
        <p02 @exit="onPopupCancelClicked" :biddingInformationParam = "biddingInformationParam" :parentPageId="this.$options.name"/>
      </sui-popup>
      <sui-popup v-model="showTermPopup" :title="$t('MSG_TIT_RTV_STD_REQ')">
        <p03 @exit="onPopupCancelClicked" :biddingInformationParam = "biddingInformationParam" :parentPageId="this.$options.name"/>
      </sui-popup>
      <sui-popup v-model="showTermPopupMeta" :title="$t('MSG_TIT_REQ_RSLT')">
        <p06 @exit="onPopupCancelClicked" :biddingInformationParam = "biddingInformationParam" :parentPageId="this.$options.name"/>
      </sui-popup>
      <sui-popup v-model="showPopup" :title="$t('MSG_TIT_RTV_STD_REQ')">
        <p01 @exit="onPopupCancelClicked" :biddingInformationParam = "biddingInformationParam" :parentPageId="this.$options.name"/>
      </sui-popup>
      <sui-popup v-model="showApplicationPopup" :title="$t('MSG_TIT_REQ_RSLT')">
        <p05 @exit="onPopupCancelClicked" :biddingInformationParam = "biddingInformationParam"  :parentPageId="this.$options.name"/>
      </sui-popup>
      <sui-popup v-model="showApprovalPopup" :title="$t('MSG_TIT_REQ_RSLT')">
        <p04 @exit="onPopupCancelClicked" :biddingInformationParam = "biddingInformationParam"   :parentPageId="this.$options.name"/>
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import p02 from './components/PGE_CMT_00005_P02';
import p03 from './components/PGE_CMT_00005_P03';
import p06 from './components/PGE_CMT_00005_P06';
import p01 from './components/PGE_CMT_00005_P01';
import p05 from './components/PGE_CMT_00005_P05';
import p04 from './components/PGE_CMT_00005_P04';
const dateTypeFields = ['applicationdate'];
export default {
  name: 'PGE_CMT_00005',
  components: {
    p02,
    p03,
    p06,
    p01,
    p05,
    p04,
  },
  data() {
    return {
      	selectedRangeDate: {},
      standardLogicNameField: '',
      applicantNameField: '',
      startDateField:'',
      // startDateField:'',
      revokeStatus:true,
      batchApproveStatus:true,
      batchRejectStatus:true,
      approveStatus:true,
      showWordPopup: false,
      showTermPopup: false,
      showMetauserBtn: false,
      showRevokeBtn: false,
      showTermPopupMeta: false,
      showPopup : false,
      showApprovalPopup: false,
      showApplicationPopup: false,
      showIfKnoxAprvN:false,
      approvalUID: '',
      biddingInformationParam: {},
      selectedAll:new Array(),
      appList: [],
      applicationUserId: this.$store.getters.userInfo.userId,
      selectData: {
        COD_DATA_STD_DIV: { label: '', key: '' },
        COD_DATA_STD_APPL_DIV: { label: '', key: '' },
        COD_DATA_STD_APRV_PRGS_STT: { label: '', key: '' },
        COD_MDLE: { label: '', key: '' },
        COD_APRV_PDNG_DIV: { label: '', key: '' },
        moduleCode: { key: '', label: '' },
        subModuleCode: { key: '', label: '' },
      },
      localdata: [],
      localdata0: [],
      defaultGridData0: {
        dataSource: {
          localdata: [],
          datatype: 'json',
          editable: true,
          selectionmode: 'singlecell',
          editmode: 'click',
        },
        altrows: true,
        showcolumnlines: false,
        showcolumnheaderlines: false,
        columns: [{
          text: this.$t('MSG_TXT_STD_TYP'),
          datafield: 'dataStandardType',
        }, {
          text: this.$t('MSG_TXT_APPL_TYP'),
          datafield: 'applicationType',
        }, {
          text: this.$t('MSG_TXT_PRCS_STT'),
          datafield: 'processingStateName',
        }, {
          text: this.$t('MSG_TXT_STD_LGC_NM'),
          datafield: 'dataStandardName',
        }, {
          text: this.$t('MSG_TXT_DESC'),
          datafield: 'description',
        }, {
          text: this.$t('MSG_TXT_APPL_DT'),
          datafield: 'applicationdate',
        }, {
          text: this.$t('MSG_TXT_MDLE'),
          datafield: 'module',
        }, {
          text: this.$t('MSG_TXT_APPL_NM'),
          datafield: 'applicantName',
        }],
      },
      defaultGridData1: {
        dataSource: {
          localdata: [],
          datatype: 'json',
          editable: true,
          selectionmode: 'singlecell',
          editmode: 'click',
        },
        altrows: true,
        showcolumnlines: false,
        showcolumnheaderlines: false,
        columns: [{
          text: this.$t('MSG_TXT_STD_TYP'),
          datafield: 'dataStandardType',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_APPL_TYP'),
          datafield: 'applicationType',
          width: 150,
        }, {
          text: this.$t('MSG_TXT_PRCS_STT'),
          datafield: 'processingState',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_STD_LGC_NM'),
          datafield: 'dataStandardName',
          width: 250,
        }, {
          text: this.$t('MSG_TXT_DESC'),
          datafield: 'description',
        }, {
          text: this.$t('MSG_TXT_APPL_DTM'),
          datafield: 'applicationdate',
          cellsrenderer: (r, c, v, h, p) => utils.dateCellRenderer(r, c, v, h, p),
          width: 150,
        }, {
          text: this.$t('MSG_TXT_MDLE'),
          datafield: 'moduleName',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_APPL_NM'),
          datafield: 'applicantName',
          createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
              displayType: "1", // "1", "2" - default: "1"
              type: 'link', // 'link', 'sublink' - default: "link"
              datafieldMap: {
                displayLanguageId: 'displayLanguageId',
                loginId: 'loginId',
                knoxId: 'knoxId',
                userName: 'userName',
                userGlobalName: 'userGlobalName',
                departmentName: 'departmentName',
                departmentEnglishName: 'departmentEnglishName',
              },
            }, this.datasetInfo, this.$refs.historyGrid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: 200,
        }],
      },
      localdata1: [],
      gridColumns1: [{
        text: this.$t('MSG_TXT_STD_TYP'),
        datafield: 'dataStandardTypeNm',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_APPL_TYP'),
        datafield: 'applicationTypeNm',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_PRCS_STT'),
        datafield: 'processingStateName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_STD_LGC_NM'),
        datafield: 'dataStandardName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickGrid,
            type: 'link',
          }, this.dsData, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 250,
      }, {
        text: this.$t('MSG_TXT_DESC'),
        datafield: 'description',
      }, {
        text: this.$t('MSG_TXT_APPL_DTM'),
        datafield: 'applicationdate',
        cellsrenderer: (r, c, v, h, p) => utils.dateCellRenderer(r, c, v, h, p),
        width: 150,
      }, {
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_APPL_NM'),
        datafield: 'applicantName',
        createwidget: (row, column, value, htmlElement) => {
          const editorInstance = utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: "1", // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              loginId: 'loginId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.dsData, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 200,
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [
    {
      id: 'dsData',
      type: 'local',
      data: 'localdata',
      datafields: [
        { name: 'dataStandardType', type: 'string', map: 'dataStandardType' },
        { name: 'applicationType', type: 'string', map: 'applicationType' },
        { name: 'dataStandardName', type: 'string', map: 'dataStandardName' },
        { name: 'dataStandardTypeNm', type: 'string', map: 'dataStandardTypeNm' },
        { name: 'applicationTypeNm', type: 'string', map: 'applicationTypeNm' },
        { name: 'dataStandardName', type: 'string', map: 'dataStandardName' },
        { name: 'processingState', type: 'string', map: 'processingState' },
        { name: 'processingStateName', type: 'string', map: 'processingStateName' },
        { name: 'applicantName', type: 'string', map: 'applicantName' },
        { name: 'fstRgstUsrId', type: 'string', map: 'fstRgstUsrId' },
        { name: 'description', type: 'string', map: 'description' },
        { name: 'moduleName', type: 'string', map: 'moduleName' },
        { name: 'applicationdate', type: 'string', map: 'applicationdate' },
        { name: 'approvalUID', type: 'string', map: 'approvalUID' },

        { name: 'displayLanguageId', type: 'string', map: 'displayLanguageId' },
        { name: 'loginId', type: 'string', map: 'loginId' },
        { name: 'knoxId', type: 'string', map: 'knoxId' },
        { name: 'userName', type: 'string', map: 'userName' },
        { name: 'userGlobalName', type: 'string', map: 'userGlobalName' },
        { name: 'departmentName', type: 'string', map: 'departmentName' },
        { name: 'departmentEnglishName', type: 'string', map: 'departmentEnglishName' },
      ],
    },
    {
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [
        {
          name: 'displayLanguageId',
          type: 'string',
          map: 'displayLanguageId',
        }, 
        {
          name: 'knoxId',
          type: 'string',
          map: 'knoxId',
        }, 
        {
          name: 'userName',
          type: 'string',
          map: 'userName',
        }, 
        {
          name: 'userName_2',
          type: 'string',
          map: 'userName_2',
        }, 
        {
          name: 'userGlobalName',
          type: 'string',
          map: 'userGlobalName',
        },
        {
          name: 'departmentName',
          type: 'string',
          map: 'departmentName',
        },
        {
          name: 'departmentEnglishName',
          type: 'string',
          map: 'departmentEnglishName',
        },
      ],
    },
    {
      id: 'datasetInfo',
      type: 'local',
      data: 'localdata1',
      datafields: [
        { name: 'dataStandardType', type: 'string', map: 'dataStandardType' },
        { name: 'applicationType', type: 'string', map: 'applicationType' },
        { name: 'dataStandardName', type: 'string', map: 'dataStandardName' },
        { name: 'processingState', type: 'string', map: 'processingState' },
        { name: 'applicantName', type: 'string', map: 'applicantName' },
        { name: 'description', type: 'string', map: 'description' },
        { name: 'moduleName', type: 'string', map: 'moduleName' },
        { name: 'applicationdate', type: 'string', map: 'applicationdate' },
        { name: 'approvalUID', type: 'string', map: 'approvalUID' },
      ],
    },
  ],
  mounted() {
    this.getSession();

    this.selectedRangeDate= {from: utils.toStringByFormat(utils.addDay(utils.now('YYYY-MM-DD'),-30), 'YYYY-MM-DD'), 
      to:utils.now('YYYY-MM-DD')};
    this.startDateField = utils.toStringByFormat(this.selectedRangeDate.from,'YYYYMMDD') + '000000';
    this.endDateField = utils.toStringByFormat(this.selectedRangeDate.to,'YYYYMMDD') + '235959';
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onClickGrid(btn, dataRow) {
      const approvalUID = dataRow.approvalUID;
      const pathParam = {
        'approval-id': approvalUID,
      };
      if(dataRow.dataStandardType === '0') {
        //Domain
        const queryParams = {
          dataStandardDivisionCode: 0,
          searchType: 'view',
          finalModificationUserId: this.applicationUserId,
          finalModificationProgramId: "PGE_CMT_00005",
        };
        http.request('PGE_CMT_00005', 'DTS_CMT_00078', {
          path: pathParam,
          query: queryParams,
        }).then(res => {
          let response = res.data;
          this.biddingInformationParam = response;
          this.showPopup = true;
        });
        
      }else if(dataRow.dataStandardType === '1') {
        //Word
        const queryParams = {
          dataStandardDivisionCode: 1,
          searchType: 'view',
          finalModificationUserId: this.applicationUserId,
          finalModificationProgramId: "PGE_CMT_00005",
        };
        http.request('PGE_CMT_00005', 'DTS_CMT_00078', {
          path: pathParam,
          query: queryParams,
        }).then(res => {
          let response = res.data;
          this.biddingInformationParam = response;
          this.showWordPopup = true;
        });
        
      }else if(dataRow.dataStandardType === '2') {
        //Term
        const queryParams = {
          dataStandardDivisionCode: 2,
          searchType: 'view',
          finalModificationUserId: this.applicationUserId,
          finalModificationProgramId: "PGE_CMT_00005",
        };
        http.request('PGE_CMT_00005', 'DTS_CMT_00078', {
          path: pathParam,
          query: queryParams,
        }).then(res => {
          let response = res.data;
          this.biddingInformationParam = response;
          this.showTermPopup = true;
        });
        
      }
    },
    cancelApplication() {
      //utils.confirm(this.$t('MSG_ALT_PRGS_CANCEL'), this.$t('MSG_TXT_YES'), this.$t('MSG_TXT_NO') , this.cancelDetail, () => {});
      utils.messageBox('confirm', this.$t('MSG_ALT_PRGS_CANCEL'), null, this.cancelDetail);
    },
    cancelDetail() {
      const queryParams = {
        approvalOpinionContent: this.$t('MSG_TXT_RJT_BY_APPL_USR'),
        approvalUID: this.approvalUID,
        finalModificationUserId: this.applicationUserId,
        finalModificationProgramId: "PGE_CMT_00005",
      };
      http.request('PGE_CMT_00005', 'DTS_CMT_00031', {
        query: queryParams,
      }).then(res => {
        if(res.data.resultCode == '1') {
          utils.messageBox('information',this.$t('MSG_TXT_REG_OK'), null, null);
          this.searchApplications();
        }
      });
    },
    reset() {
      this.$refs.standardTypeOptions.reset();
      this.$refs.appTypeOptions.reset();
      this.$refs.processingStateOptions.reset();
      //this.$refs.moduleOptions.reset();
      this.selectData.moduleCode.key='ALL';
      this.selectData.subModuleCode.key='ALL';
      this.standardLogicNameField = '';
      this.applicantNameField = '';
      this.selectedRangeDate = { from: utils.toStringByFormat(utils.addDay(utils.now('YYYY-MM-DD'),-30), 'YYYY-MM-DD'), 
        to:utils.now('YYYY-MM-DD')};
      this.startDateField = utils.toStringByFormat(this.selectedRangeDate.from,'YYYYMMDD') + '000000' ;
      this.endDateField = utils.toStringByFormat(this.selectedRangeDate.to,'YYYYMMDD') + '235959';
      this.$refs.pendencyOptions.reset();

    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
        
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
    // sonarcube codesmell 대응
    // checkRequiredDateField(){
    //   // if(this.onClickValidate()) return false;
    //   let fromDt = utils.toStringByFormat(this.selectedRangeDate.from,'YYYYMMDD')+'000000';
    //   let toDt = utils.toStringByFormat(this.selectedRangeDate.to,'YYYYMMDD')+'000000';
    //   console.log ( fromDt + " + " + toDt) ;

    //   if (!( fromDt && toDt) ){
    //     utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL') ,  this.$t('MSG_TXT_APPL_DT')) , null);
    //     return true;
    //   }
    //   return false;
    // },
    searchApplications() {
      //disabling buttons on search
      //console.log ("test ");
      if (this.onClickValidate()) return false;
      // sonarcube codesmell 대응
      // if (this.checkRequiredDateField()) return false ;

      this.dsData.setRawData([]);

      this.revokeStatus=true;
      this.approveStatus=true;
      this.batchApproveStatus=true;
      this.batchRejectStatus=true;
      const queryParams = {
        dataStandardDivisionCode : this.$refs.standardTypeOptions.currentSelected.codeId || '',
        dataStandardApplicationDivisionCode : this.$refs.appTypeOptions.currentSelected.codeId || '',
        dataStandardName : this.standardLogicNameField || '',
        module : this.$refs.moduleOptions.selected.md.codeId || '',
        approvalStatusCode : this.$refs.processingStateOptions.currentSelected.codeId || '',
        startDate : this.startDateField || '',
        endDate : this.endDateField || '',
        firstRegistUserId : this.applicantNameField || '',
        pendency : this.$refs.pendencyOptions.currentSelected.codeId || '',
      };
      http.request('PGE_CMT_00005', 'DTS_CMT_00028', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);
        this.dsData.setRawData(res.data);
        this.appList = this.dsData.originalData;
        this.selectedAll = [];
      });
    },
    excelDownload() {
      utils.downloadGridToExcel(this.$options.name, this.gridColumns1, this.dsData, "excel-export.xlsx");
      /*const queryParams = {
          dataStandardDivisionCode : this.$refs.standardTypeOptions.currentSelected.codeId || '',
          dataStandardApplicationDivisionCode : this.$refs.appTypeOptions.currentSelected.codeId || '',
          dataStandardName : this.standardLogicNameField || '',
          module : this.$refs.moduleOptions.selected.md.codeId || '',
          approvalStatusCode : this.$refs.processingStateOptions.currentSelected.codeId || '',
          startDate : this.startDateField || '',
          endDate : this.endDateField || '',
          firstRegistUserId : this.applicantNameField || '',
          pendency : this.$refs.pendencyOptions.currentSelected.codeId || ''
        };
        http.request('PGE_CMT_00005', 'DTS_CMT_00029', {
          path: {
          'page-id': 'PGE_CMT_00005',
        },
        query: queryParams,
          responseType: 'arraybuffer'
        }).then((res) => {
          let fileName = "ApplicationList.xlsx";
          utils.downloadBlob(res, fileName);
        })*/
    },
    getSession() {
      //this.sessionInfo = this.$store.getters.userInfo;

      // 환경설정 값 knox결재 여부가 N인 경우에만 화면에서 결재 처리 가능 하도록 조건 추가.
      // utils.isEqual(utils.getConfigurationValue('CFG_CMT_KNOX_APRV_YN'),'N'))
        
      if ( utils.isEqual(utils.getConfigurationValue('CFG_CMT_KNOX_APRV_YN'),'N')) {
        this.showIfKnoxAprvN = true ;
      }
        
        
      if ( utils.hasRoleNickName('DTA_STD_ADMIN') ){
        //if(this.sessionInfo.roleList[0].roleNickName == ) {
        this.showMetauserBtn = true;
      }
        
      this.sessionInfo = this.$store.getters.userInfo;
      console.log(utils.hasRoleNickName('DTA_STD_ADMIN'));
      if(utils.hasRoleNickName('DTA_STD_ADMIN') && utils.isEqual(utils.getConfigurationValue('CFG_CMT_KNOX_APRV_YN'),'N')) {
        this.showMetauserBtn = true;
      }
        
    },
    multiSelect()
    {
      const selectedIndexes =this.dsData.getSelectedIndexes();
      if(selectedIndexes.length > 0)
      {
        const indexlength= selectedIndexes.length - 1;
        const lastIndex = selectedIndexes[indexlength];
        console.log(selectedIndexes);
        let findConflict = 0;
        utils.forEach(selectedIndexes, index => {
          if(this.dsData.data[index].applicantName != this.$store.getters.userInfo.epid)
          {
            this.revokeStatus=true;
          }
          else
            this.revokeStatus=false;
        });
        //disabling buttons if not request
          
        utils.forEach(selectedIndexes, index => {
          if(this.dsData.data[index].processingState!='0')
          {
            findConflict++;
          }
        });
        console.log(findConflict);
        if (findConflict > 0)
        {  console.log('disabling buttons')
          this.revokeStatus=true;
          this.approveStatus=true;
          this.batchApproveStatus=true;
          this.batchRejectStatus=true;

        }
        else {
          this.approveStatus=false;
          this.batchApproveStatus=false;
          this.batchRejectStatus=false;
        }
        //disabling individual approval when more than 1 request
        if(selectedIndexes.length > 1 && findConflict=== 0 )
        {
          this.approveStatus=true;
        }
     
      }//disabling when unselecting
      else {
        this.approveStatus=true;
        this.batchApproveStatus=true;
        this.batchRejectStatus=true;
      }
    },
      
    onSelectRow(target){
      console.log('checking index',this.dsData);
      setTimeout(()=>{ this.OnSelectRowCall(target)}, 500);
        
    },
    OnSelectRowCall(target){
        
      if(!target.args.row) {
        this.multiSelect();
        return false;
      }
      const selectedIndexes =this.dsData.getSelectedIndexes();
       
      let findConflict = 0;

      if(target.args.row.applicantName != this.$store.getters.userInfo.epid)
      {
        this.revokeStatus=true;
      }
      else
        this.revokeStatus=false;
      console.log("processingState  " + target.args.row.processingState )
      if(target.args.row.processingState!='0')
      {
        console.log('disabling buttons')
        this.revokeStatus=true;
        this.approveStatus=true;
        this.batchApproveStatus=true;
        this.batchRejectStatus=true;
      }
      else {
        this.approveStatus=false;
        this.batchApproveStatus=false;
        this.batchRejectStatus=false;
      }

      let datastdType;
      let appType;
      let dataStdType = target.args.row.dataStandardType;
      let apptype = target.args.row.applicationType;

      if(dataStdType === '0') {
        datastdType = 0;
      }else if(dataStdType === '1') {
        datastdType = 1;
      }else if(dataStdType === '2') {
        datastdType = 2;
      }

      if(apptype === '0') {
        appType = 0;
      }else if(apptype === '1') {
        appType = 1;
      }else if(apptype === '2') {
        appType = 2;
      }
      this.selectedAll.push({
        approvalUID : target.args.row.approvalUID,
        processingState:target.args.row.processingState,
        dataStandardType : datastdType,
        applicationType: appType,
        description: this.$t('MSG_TXT_DTA_PRGS_CNTN'),
        id:target.args.rowindex,
        finalModificationUserId: this.applicationUserId,
        finalModificationProgramId: "PGE_CMT_00005",

      })

      if(this.selectedAll.length>1)
      {
        console.log(' inside select ')
        for(let i=0;i<this.selectedAll.length; i++){
          this.approveStatus=true;
          //disabling if processing state is not request type
          if(this.selectedAll[i].processingState!='0')
          { 
            console.log(' inside select loop')
            findConflict++;
          }
        }
      }
      if(findConflict > 0)
      {
        console.log ('conflicting in select')
        this.approveStatus=true;
        this.batchApproveStatus=true;
        this.batchRejectStatus=true;
               
      }
      
      console.log(this.selectedAll);
      this.approvalUID = target.args.row.approvalUID;
      console.log('calling target');
      console.log(dataStdType);
      http.request('PGE_CMT_00005', 'DTS_CMT_00038', {
        query: {
          'standardDivisionCode':  dataStdType,
          'standardLogicName': target.args.row.dataStandardName,

        },
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);
        this.localdata1 = res.data;
        this.defaultGridData1.dataSource.localdata = [];
        this.datasetInfo.setRawData(this.localdata1);
      }).catch(error => {
        this.confirm(1, error);
      });
    }
    
    ,
    onUnselectRow(target){
      const selectedIndexes =this.dsData.getSelectedIndexes();
        
      let findConflict=0;
      for(let i=0;i<this.selectedAll.length; i++){  
        if(this.selectedAll[i].id==target.args.rowindex)
        {
          this.selectedAll.splice(i,1);

          break;
        }//disabling if processing state is not request type
            
      }
      //disabling if found conflict 
      utils.forEach(this.selectedAll, element => {
        if(element.processingState!='0')
        {
          findConflict++;
        }
      });

      if(findConflict >0 && this.selectedAll.length > 0)
      {
        this.approveStatus=true;
        this.batchApproveStatus=true;
        this.batchRejectStatus=true;
      }
      else {
        this.approveStatus=false;
        this.batchApproveStatus=false;
        this.batchRejectStatus=false;
      }
      console.log('after unselect');
      console.log(this.selectedAll.length);
      if(this.selectedAll.length == 1 && findConflict === 0 )
      {
        console.log('in unselect');
        this.approveStatus=false;
      } 
      else 
      {
        this.approveStatus=true;
      }

      if(this.selectedAll.length < 1 )
      {
        console.log('disabling batch');
        //this.approveStatus=true;
        this.batchApproveStatus=true;
        this.batchRejectStatus=true;
      }
      if(selectedIndexes.length < 1 )
      {
        this.revokeStatus=true;
        this.approveStatus=true;
        this.batchApproveStatus=true;
        this.batchRejectStatus=true;
      }

    },
    onConfirm() {

      if (this.onClickValidate()) return false;

      this.startDateField = utils.toStringByFormat(this.selectedRangeDate.from,'YYYYMMDD')+'000000';
      this.endDateField = utils.toStringByFormat(this.selectedRangeDate.to,'YYYYMMDD')+'235959';
      console.log('start date after formatting-->',this.startDateField);
      console.log('end date after formatting-->',this.endDateField);

    },
    batchApprove() {
      let batchApproveStatus=false;
      for(let i=0;i<this.selectedAll.length; i++){

        if(this.selectedAll[i].processingState !='0')
        {
          batchApproveStatus=true;
        }

      }
      if(!batchApproveStatus){
        //utils.confirm(this.$t('MSG_ALT_BAT_PRGS'), this.$t('MSG_TXT_YES'), this.$t('MSG_TXT_NO')  , this.okBatchApprove, () => {});
        utils.messageBox('confirm', this.$t('MSG_ALT_BAT_PRGS'), null, this.okBatchApprove);

      }else utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_STT_IS_NOT_APPR') , null));
    },
    okBatchApprove() {
      http.request('PGE_CMT_00005', 'DTS_CMT_00034', {
        data : this.selectedAll,
      }).then(res => {
        if(res.data.resultCode == '1') {
          utils.messageBox('information',this.$t('MSG_TXT_DTA_PRGS_CNTN'), null, null);
          this.searchApplications();
        }
      });
    },
    batchReturn() {
      let rejectStatus=false;
      for(let i=0;i<this.selectedAll.length; i++){

        if(this.selectedAll[i].processingState !='0')
        {
          rejectStatus=true;
        }
      }
      if(!rejectStatus){
        //utils.confirm(this.$t('MSG_ALT_BAT_PRGS'), 'YES', 'NO' , this.okBatchReturn, () => {});
        utils.messageBox('confirm', this.$t('MSG_ALT_BAT_PRGS'), null, this.okBatchReturn);
      }
      else utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_REQ_NOT_FOR_RJT') , null));
    },
    okBatchReturn() {
      http.request('PGE_CMT_00005', 'DTS_CMT_00035', {
        data : this.selectedAll,
      }).then(res => {
        if(res.data.resultCode == '1') {
          utils.messageBox('information',this.$t('MSG_TXT_DTA_PRGS_CNTN'), null, null);
          this.searchApplications();
        }
      });
    },
    individualApprove() {

      let dataStdType = this.selectedAll[0].dataStandardType;
      const approvalUID = this.selectedAll[0].approvalUID;
      const pathParam = {
        'approval-id': approvalUID,
      };
      if(dataStdType == 0) {
        const queryParams = {
          dataStandardDivisionCode: 0,
          searchType: 'view',
          finalModificationUserId: this.applicationUserId,
          finalModificationProgramId: "PGE_CMT_00005",
        };
        http.request('PGE_CMT_00005', 'DTS_CMT_00078', {
          path: pathParam,
          query: queryParams,
        }).then(res => {
          let response = res.data;
          this.biddingInformationParam = response;
          this.showApprovalPopup = true;
        });

      }else if(dataStdType == 1) {
        const queryParams = {
          dataStandardDivisionCode: 1,
          searchType: 'view',
          finalModificationUserId: this.applicationUserId,
          finalModificationProgramId: "PGE_CMT_00005",
        };
        http.request('PGE_CMT_00005', 'DTS_CMT_00078', {
          path: pathParam,
          query: queryParams,
        }).then(res => {
          let response = res.data;
          this.biddingInformationParam = response;
          this.showApplicationPopup = true;
        });

      }else if(dataStdType == 2) {
        const queryParams = {
          dataStandardDivisionCode: 2,
          searchType: 'view',
          finalModificationUserId: this.applicationUserId,
          finalModificationProgramId: "PGE_CMT_00005",
        };
        http.request('PGE_CMT_00005', 'DTS_CMT_00078', {
          path: pathParam,
          query: queryParams,
        }).then(res => {
          let response = res.data;
          this.biddingInformationParam = response;
          this.showTermPopupMeta = true;
        });

      }
    },
    onKeyUpInput(event, name , value) {
      //const searchFieldNewText = this.frame0[name];
      
      if (utils.isExistSpecialChar(value)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          if(name === 'applicantName')
          {
            this.applicantNameField=''
          }
          else this.standardLogicNameField='';
          //this.$refs[name].setFocus();
        });
      } 
    
    },
    onPopupCancelClicked() {
      this.showTermPopupMeta = false;
      this.showPopup = false;
      this.showTermPopup=false;
      this.showWordPopup = false;
      this.showApplicationPopup= false;
      this.showApprovalPopup= false;
      //this.showTermPopupMeta = false;
       
      this.searchApplications();
    },
  },
};
</script>
<style scoped>
</style>
